<app-selector label="Division" [isEmptySelectable]="false" [data]="divisionCoreService.visibleDivisions$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="divisionCoreService.loading$ | async" [hint]="hint">
</app-selector>